export type Platform = {
  id: string
  name: string
  nameFA: string
  stat: { en: string; fa: string }
  desc: { en: string; fa: string }
  color: string
  category: 'social' | 'messenger'
  heroStat1?: { val: { en: string; fa: string }; label: { en: string; fa: string } }
  heroStat2?: { val: { en: string; fa: string }; label: { en: string; fa: string } }
  heroFormats?: { en: string[]; fa: string[] }
  heroHighlight?: { en: string; fa: string }
}

export const socialPlatforms: Platform[] = [
  {
    id: 'instagram',
    name: 'Instagram',
    nameFA: 'اینستاگرام',
    stat: {
      en: '10,000+ Influencers',
      fa: '+۱۰،۰۰۰ اینفلوئنسر',
    },
    desc: {
      en: 'Primary influencer channel, micro to mega',
      fa: 'کانال اصلی اینفلوئنسر، از میکرو تا مگا',
    },
    color: '#E1306C',
    category: 'social',
    heroStat1: {
      val: { en: '10,000+', fa: '۱۰،۰۰۰+' },
      label: { en: 'Influencers', fa: 'اینفلوئنسر' },
    },
    heroStat2: {
      val: { en: '113M+', fa: '۱۱۳ میلیون+' },
      label: { en: 'Monthly Visits', fa: 'بازدید ماهانه' },
    },
    heroFormats: {
      en: ['Story', 'Reel', 'Feed Post', 'Collaboration', 'Live'],
      fa: ['استوری', 'ریل', 'پست فید', 'کولبریشن', 'لایو'],
    },
    heroHighlight: {
      en: 'An extensive network of influencers across Iran; from micro to mega, with integrated campaign management.',
      fa: 'شبکه‌ای گسترده از اینفلوئنسرهای سراسر ایران؛ از میکرو تا مگا، با مدیریت یکپارچه کمپین.',
    },
  },
  {
    id: 'telegram',
    name: 'Telegram',
    nameFA: 'تلگرام',
    stat: { en: 'Advertising Channels', fa: 'کانال‌های تبلیغاتی' },
    desc: {
      en: 'Channel posts, reportage, Telegram Ads management',
      fa: 'پست کانال، رپورتاژ، مدیریت Telegram Ads',
    },
    color: '#2AABEE',
    category: 'social',
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    nameFA: 'واتساپ',
    stat: { en: 'Active Channels & Groups', fa: 'کانال و گروه‌های فعال' },
    desc: {
      en: 'Post + Status, ideal for 25-45 age bracket',
      fa: 'پست + استاتوس، ایده‌آل برای میانسال',
    },
    color: '#25D366',
    category: 'social',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    nameFA: 'یوتیوب',
    stat: { en: 'Long-form Video ROI', fa: 'بازده ویدیوی بلند' },
    desc: {
      en: 'High-retention content with measurable attribution',
      fa: 'محتوای ماندگار با انتساب قابل اندازه‌گیری',
    },
    color: '#E03C3C',
    category: 'social',
    heroStat1: {
      val: { en: '10M+', fa: '۱۰ میلیون+' },
      label: { en: 'Active Iranian Users', fa: 'کاربر فعال ایرانی' },
    },
    heroStat2: {
      val: { en: '100M+', fa: '۱۰۰ میلیون+' },
      label: { en: 'Iranian YouTube Views', fa: 'بازدید کاربران ایرانی' },
    },
    heroFormats: {
      en: ['Pre-roll', 'Mid-roll', 'Sponsored Video', 'Shorts', 'End Screen'],
      fa: ['پری‌رول', 'میدرول', 'ویدیوی اسپانسری', 'شورتز', 'صفحه پایانی'],
    },
    heroHighlight: {
      en: "Visibility on the world's largest video platform.",
      fa: 'دیده‌شدن در بزرگ‌ترین بستر محتوای ویدیویی جهان.',
    },
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    nameFA: 'لینکدین',
    stat: { en: 'B2B Positioning', fa: 'پوزیشنینگ B2B' },
    desc: {
      en: 'Specialist B2B campaigns and professional brand presence',
      fa: 'کمپین تخصصی B2B و حضور برند حرفه‌ای',
    },
    color: '#0A66C2',
    category: 'social',
    heroStat1: {
      val: { en: '4M+', fa: '۴ میلیون+' },
      label: { en: 'Iranian Users', fa: 'کاربر ایرانی' },
    },
    heroStat2: {
      val: { en: '3M+', fa: '۳ میلیون+' },
      label: { en: 'Professional & Specialized Audience', fa: 'مخاطبان حرفه‌ای و تخصصی' },
    },
    heroFormats: {
      en: ['Sponsored Post', 'InMail', 'Article', 'Company Page', 'Job Ad'],
      fa: ['پست اسپانسری', 'اینمیل', 'مقاله', 'صفحه شرکت', 'آگهی شغلی'],
    },
    heroHighlight: {
      en: 'Connecting with professionals; in a specialized and credible environment.',
      fa: 'ارتباط با جامعه حرفه‌ای، در بستری تخصصی و معتبر.',
    },
  },
  {
    id: 'twitter',
    name: 'Twitter / X',
    nameFA: 'توییتر / X',
    stat: { en: 'Trending & Real-time', fa: 'ترند و لحظه‌ای' },
    desc: {
      en: 'Real-time audience interaction and trend creation',
      fa: 'تعامل لحظه‌ای و ایجاد ترند',
    },
    color: '#e7e9ea',
    category: 'social',
    heroStat1: {
      val: { en: '2M+', fa: '۲ میلیون+' },
      label: { en: 'Active Iranian Users', fa: 'کاربر ایرانی فعال' },
    },
    heroStat2: {
      val: { en: 'Fast Execution, Real Results', fa: 'اجرای سریع، نتیجه واقعی' },
      label: { en: '', fa: '' },
    },
    heroFormats: {
      en: ['Tweet', 'Thread', 'Trending Hashtag', 'Space', 'Promoted'],
      fa: ['توییت', 'ترِد', 'هشتگ ترند', 'اسپیس', 'پروموتد'],
    },
    heroHighlight: {
      en: 'A platform for rapid visibility and real-time audience reaction.',
      fa: 'پلتفرمی برای دیده‌شدن سریع و واکنش لحظه‌ای مخاطبان.',
    },
  },
]

export const iranianMessengers: Platform[] = [
  {
    id: 'rubika',
    name: 'Rubika',
    nameFA: 'روبیکا',
    stat: { en: '44M Active Users', fa: '۴۴ میلیون کاربر فعال' },
    desc: {
      en: '350M+ daily home-page impressions, pre-roll + Rubino bloggers',
      fa: '۳۵۰+ میلیون ایمپرشن روزانه، پری‌رول + بلاگر روبینو',
    },
    color: '#794387',
    category: 'messenger',
  },
  {
    id: 'ita',
    name: 'Eitaa',
    nameFA: 'ایتا',
    stat: { en: '30M+ Active Users', fa: '۳۰+ میلیون کاربر فعال' },
    desc: {
      en: 'Broadcast + Pin-to-top (nationwide & provincial targeting)',
      fa: 'نشر گسترده + پین تو تاپ (سراسری و استانی)',
    },
    color: '#059669',
    category: 'messenger',
  },
  {
    id: 'bale',
    name: 'Bale',
    nameFA: 'بله',
    stat: { en: '15M+ Users / 23M Installs', fa: '۱۵+ میلیون کاربر / ۲۳ میلیون نصب' },
    desc: {
      en: 'Pin-to-top + Pv-to-Pv direct message delivery',
      fa: 'پین تو تاپ + پیام مستقیم Pv to Pv',
    },
    color: '#D97706',
    category: 'messenger',
  },
  {
    id: 'soroush',
    name: 'Soroush+',
    nameFA: 'سروش+',
    stat: { en: '10M Users', fa: '۱۰ میلیون کاربر' },
    desc: {
      en: 'Push notifications + pop-up + broadcast channels',
      fa: 'پوش نوتیفیکیشن + پاپ‌آپ + کانال نشر گسترده',
    },
    color: '#2a7a96',
    category: 'messenger',
  },
  {
    id: 'messengers',
    name: '1,000+ Channels',
    nameFA: '۱،۰۰۰+ کانال',
    stat: { en: 'Iranian Messengers', fa: 'پیام‌رسان‌های ایرانی' },
    desc: {
      en: 'Coordinated multi-messenger broadcast in a single campaign',
      fa: 'نشر هماهنگ در چند پیام‌رسان در یک کمپین',
    },
    color: '#4F46E5',
    category: 'messenger',
  },
]
